import { takeLatest, put, select } from 'redux-saga/effects'
import cookie from 'react-cookies'
import qs from 'query-string'
import request from '@/helpers/axios'
import { getRouterLocation } from '@/store/selectors/router'
import { RESET_PASSWORD_API_URL } from '@/constants/apiRoutes'
import {
  USER_SET_PASSWORD,
} from '@/store/actions/user'
import {
  PASSWORD,
  PASSWORD_CONFIRMATION,
} from '@/constants/forms/signUp'
import {
  successSetPassword,
  errorSetPassword,
} from '@/store/actions/user/setPassword'
import { SLS24_ACCESS_TOKEN } from '@/constants/names'

const ERRORS = {
  'resource_not_found.user_id': 'Невозможно найти пользователя',
  'resource_not_found.password_token': 'Истекло время установки пароля. Запросите новую ссылку для установки пароля',
  'access_denied.user_edit:password_exist': 'Пароль уже установлен',
  'validation_failed.password:invalid': 'Пароль не соответствует требованиям',
  'validation_failed.password:is_dictionary_word': 'Пароль не соответствует требованиям',
  'validation_failed.password:empty': 'Пароль не должен быть пустым',
}

function* setUserPassword({ payload }) {
  const { form } = payload
  const { search } = yield select(getRouterLocation)
  const { token } = qs.parse(search)

  try {
    const { data } = yield request({
      url: `${RESET_PASSWORD_API_URL}?token=${token}`,
      method: 'put',
      body: form.values[PASSWORD],
      isSecure: false,
    })
    cookie.remove(
      SLS24_ACCESS_TOKEN,
      { path: '/' },
    )
    yield put(successSetPassword(data))
  } catch (error) {
    console.log('function*setUserPassword -> error', error)
    form.form.setSubmitting(false)
    form.form.setErrors({
      [PASSWORD_CONFIRMATION]: ERRORS[error.response.data.errorCode],
    })
    yield put(errorSetPassword(error))
  }
}

export default function* root() {
  yield takeLatest(USER_SET_PASSWORD.BEGIN, setUserPassword)
}
